// Base reports need Checklist to adopt the base report's model on comparison; off until that is live
export const isBaseReportEnabled = () => process.env.VUE_APP_BASE_REPORT_ENABLED === 'true'
